import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { DataService } from '../../../core/service/base/data.service';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { InvoiceTransaction } from '../../model/invoice-transaction';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class InvoiceTransactionService extends DataService<InvoiceTransaction> {
  constructor(
    private httpClient: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig,
    messageService: MessageService,
    progressBar: ProgressBarService
  ) {
    super(httpClient, config, messageService, InvoiceTransaction, progressBar, 'invoice-transaction');
  }

  export(ids: string[]): Observable<File> {
    return super.exportDataItems(ids, 'Inbetalningar.xlsx');
  }

  void(id: string): Observable<any> {
    return this.client.post<any>(`${this.endpoint}/void`, { transactionId: id }).pipe(
      catchError(err => {
        this.notification.showError(err);
        throw err;
      })
    );
  }
}
